import {Store} from "pullstate";
import _ from "../../src/_/index";
import indexBy from "underscore/modules/indexBy";
import {UserCouponBookmarkStore, UserEventActivityStore, UserEventTestStore, UserPostBookmarkStore, UserPostFavorStore, UserTokenEntrustStore} from "./Common_Store";
import {filter} from "ionicons/icons";
import {handleExecutor} from "../pages/Utils";
import {Pg_4_4_Store, push_pg_4_2__AddCouponBookmark} from "./Pg_4_Store";

export const Pg_8_1_Store = new Store({});
export const Pg_8_2_Store = new Store({});

export const Pg_8_3_Store = new Store({});

export const Pg_8_4_Store = new Store({});

export const Pg_8_5_Store = new Store({});


let fetchOption = (postParams) => {
    return {
        method: 'POST', // *GET, POST, PUT, DELETE, etc.
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin', // include, *same-origin, omit
        headers: {
            'Content-Type': 'application/json'
            // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: 'follow', // manual, *follow, error
        referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(postParams) // body data type must match "Content-Type" header
    } as any;
};

//#region 8_1
export const fetch_Pg_8_1 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_1`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_8_1_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

//#endregion

//#region 8_2
export const fetch_Pg_8_2 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_2`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_8_2_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const fetch_Pg_8_3 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_3`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_8_3_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const fetch_Pg_8_4 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_4`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_8_4_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const fetch_Pg_8_5 = async () => {
    let postParams = {}
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/pg_8_5`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        Pg_8_5_Store.update(s => {
            return Object.assign(s, payload)
        });

        // if (payload.Root.Attach_List_會員_Token__委託關注) {
        //     let keyed = indexBy(payload.Root.Attach_List_會員_Token__委託關注, 'TokenId');
        //
        //     UserTokenEntrustStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        // }

        await handleExecutor(payload.__Executor);
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    // await data.filter((quote, index) => {
    //     quote.id = (Date.now() + index);
    //     quote.image = `https://source.unsplash.com/random/1200x400?sig=${ quote.id }`;
    // });
}

export const push_pg_8_2 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_2`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_2_Store.update(s => {
            return Object.assign(s, {
                Root: payload
            })
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_8_3 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_3`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_3_Store.update(s => {
            return Object.assign(s, {
                Root: payload
            })
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_8_4 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_4`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_4_Store.update(s => {
            return Object.assign(s, {
                Root: payload
            })
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_8_5 = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_5`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_5_Store.update(s => {
            return Object.assign(s, {
                Root: payload
            })
        });
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_8_5__scan = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_5/keyin`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_5_Store.update(s => {
            return Object.assign(s, payload)
        });
        alert(payload.Message);
        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}

export const push_pg_8_5__exportexcel = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_5/exportexcel`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_5_Store.update(s => {
            return Object.assign(s, {
                ExportExcel: payload
            })
        });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
export const push_pg_8_2__exportexcel = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_2/exportexcel`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_2_Store.update(s => {
            return Object.assign(s, {
                ExportExcel: payload
            })
        });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
export const push_pg_8_3__exportexcel = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_3/exportexcel`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_3_Store.update(s => {
            return Object.assign(s, {
                ExportExcel: payload
            })
        });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
export const push_pg_8_4__exportexcel = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_4/exportexcel`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_4_Store.update(s => {
            return Object.assign(s, {
                ExportExcel: payload
            })
        });

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
export const push_pg_8_2__scan = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_2/scan`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_2_Store.update(s => {
            return Object.assign(s, payload)
        });

        alert(payload.Message);

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
export const push_pg_8_3__scan = async (postParams: {}) => {
    const response = await fetch(`${_._s.API_ROOT_URL}/api/1/_pg_8_3/scan`, fetchOption(postParams));
    const data = await response.json();

    let error = data.error || null;
    let result = error == null;

    if (result) { // SUCEESS
        let payload = data.payload;
        _._d.warn(payload);
        // Pg_3_11_Store.update(s => {
        //     let o: any = s;
        //     Object.assign(o, payload);
        //     o._pg_3_1 = payload;
        //     return o;
        // });
        // if (payload.Attach_List_會員_Sdgs課程__參加) {
        //     let keyed = indexBy(payload.Attach_List_會員_Sdgs課程__參加, 'Sdgs課程Id');
        //
        //     UserEventTestStore.update(s => {
        //         return Object.assign(s, keyed)
        //     });
        //
        //     delete payload.Attach_List_會員_Sdgs課程__參加;
        // }

        Pg_8_5_Store.update(s => {
            return Object.assign(s, payload)
        });

        alert(payload.Message);

        return result;
    } else {
        if (error.code === 2) {
            return error;
        }
        alert(error.message);
        throw (error.message);
    }

    return false;
}
//#endregion
